/**
 * Pays où Donoor sert des associations, tels que les annoncent les données
 * structurées (`areaServed` de l'Organization, des Service et du graphe de
 * connaissances).
 *
 * Analyse GEO du 01/11/2026 : toutes ces données disaient « France » seule,
 * alors que la Belgique, le Luxembourg et Monaco sont ouverts aux paiements
 * en prod depuis le 28-29/10 (backup-manager › Pays). Les moteurs et les IA
 * lisaient donc Donoor comme une plateforme réservée à la France.
 *
 * À mettre à jour quand un pays ouvre ses paiements (reglages_pays en prod,
 * PROFILS dans packages/utils/src/profilPays.ts) : pas avant, pour ne jamais
 * annoncer un pays où une association ne peut pas encore encaisser.
 */
export const PAYS_SERVIS = [
  { code: "FR", nom: "France" },
  { code: "BE", nom: "Belgique" },
  { code: "LU", nom: "Luxembourg" },
  { code: "MC", nom: "Monaco" },
  // Pays-Bas (01/11/2026) : à mettre en ligne AVEC l'ouverture des paiements.
  { code: "NL", nom: "Pays-Bas" },
  // Allemagne (03/11/2026) : à mettre en ligne AVEC l'ouverture des paiements.
  { code: "DE", nom: "Allemagne" },
] as const;

/** `areaServed` schema.org : un objet Country par pays servi. */
export function zoneServieSchema(): Array<{ "@type": "Country"; name: string; identifier: string }> {
  return PAYS_SERVIS.map((p) => ({ "@type": "Country", name: p.nom, identifier: p.code }));
}

/** Codes ISO des pays servis (ContactPoint.areaServed accepte des chaînes). */
export const CODES_PAYS_SERVIS: readonly string[] = PAYS_SERVIS.map((p) => p.code);

/**
 * Pays hors France qui ont leur page sur donoor.org (/belgium, /luxembourg,
 * /netherlands, /germany).
 * Le bloc « Dans votre pays » (app/components/pays/DansVotrePays.vue) en fait
 * une carte sur chaque page qui parle de reçus ou de paiements : ouvrir un
 * nouveau pays = ajouter sa ligne ici, sa page, et ses textes dans
 * i18n/pages/components/pays/DansVotrePays.json — toutes les pages suivent.
 */
export const PAYS_AVEC_PAGE = [
  { code: "BE", chemin: "/belgium" },
  { code: "LU", chemin: "/luxembourg" },
  { code: "NL", chemin: "/netherlands" },
  { code: "DE", chemin: "/germany" },
] as const;
